/* eslint-disable react/jsx-props-no-spreading */
import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';
import type { UseComboboxPropGetters } from 'downshift';
import type { CommandPaletteSearchFEResult } from '../../../shared/CommandPalette/types';
import styles from './LinkResult.module.less';
import { Link } from '../generic';

type Props = ReturnType<UseComboboxPropGetters<CommandPaletteSearchFEResult>['getItemProps']> & {
  to: string;
  label: string;
  isHighlighted: boolean;
};

/**
 * A list item representing a single search result, optionally highlighted
 */
const LinkResult: VoidFunctionComponent<Props> = ({ to, label, isHighlighted, ...props }) => {
  return (
    <li {...props} className={cx(styles.resultItem, isHighlighted && styles.resultItemHighlighted)}>
      <Link to={to} className={styles.resultItemLink}>
        {label}
      </Link>
    </li>
  );
};

export default LinkResult;
